<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Rechtliche Hinweise</h2>
      <p class="form-page__subtitle">* Pflichtfelder</p>
    </div>

    <div class="form-section">
      <div class="info-box info-box--blue">
        <span class="info-box__icon">⚖️</span>
        <div>
          Bitte beachten Sie die <strong>Baumschutzverordnung</strong>. Für die Fällung, den
          Rückschnitt oder sonstige Eingriffe an geschützten Bäumen ist grundsätzlich eine
          Ausnahmegenehmigung der zuständigen Behörde erforderlich.
        </div>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">Rechtsgrundlage</h3>
        <p>
          Die Erteilung einer Ausnahmegenehmigung richtet sich nach der Verordnung zum Schutz des
          Baumbestandes (Baumschutzverordnung) in der jeweils geltenden Fassung. Ein Verstoß gegen
          die Verordnung kann als Ordnungswidrigkeit geahndet werden.
        </p>
      </div>

      <div class="legal-block">
        <h3 class="legal-block__title">Verarbeitung Ihrer Daten</h3>
        <p>
          Die im Rahmen dieses Antrags übermittelten Daten und Dokumente werden ausschließlich zur
          Prüfung und Bearbeitung Ihres Antrags auf Ausnahmegenehmigung verwendet und gemäß den
          geltenden datenschutzrechtlichen Bestimmungen verarbeitet.
        </p>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">Zustimmung <span class="required-mark">*</span></h3>
      <label class="checkbox-label" :class="{ checked: modelValue.confirm_rechtliche_hinweise }">
        <input
          type="checkbox"
          class="checkbox-input"
          :checked="modelValue.confirm_rechtliche_hinweise"
          @change="update('confirm_rechtliche_hinweise', $event.target.checked)"
        />
        Ich habe die rechtlichen Hinweise zur Baumschutzverordnung zur Kenntnis genommen und
        stimme der Verarbeitung meiner Daten zum Zweck der Antragsbearbeitung zu.
        <span class="required-mark">*</span>
      </label>
      <p v-if="showErrors && !modelValue.confirm_rechtliche_hinweise" class="field__error" style="margin-top:6px">
        ⚠ Bitte bestätigen Sie die rechtlichen Hinweise, um fortzufahren.
      </p>
    </div>

    <p class="required-note"><span class="required-mark">*</span> Pflichtfelder</p>
  </div>
</template>

<script>
export default {
  name: 'BaumRechtlicheHinweiseStep',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const update = (key, val) => emit('update:modelValue', { ...props.modelValue, [key]: val });
    return { update };
  },
};
</script>

<style scoped src="../form.css"></style>
